import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'shabic-icon-phone',
  templateUrl: './icon-phone.component.html',
  styleUrls: ['./icon-phone.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconPhoneComponent {}
